import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';
import { IEndpointData } from 'SharedDir/declarations/shared';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';

// eslint-disable-next-line max-len
export const BASE_PROFILE_TYPE_URL = `${SERVER_API}/steps/sections/fields/link-from-profile/profile-types`;

export const PROFILE_TYPE_ENDPOINTS = {
  LIST: {
    method: 'GET',
    url: `${BASE_PROFILE_TYPE_URL}`,
  } as IEndpointData,
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_PROFILE_TYPE_URL}/${id.toString()}`,
    };
  },
  SECTIONS: {
    LIST: {
      method: 'GET',
      url: `${BASE_PROFILE_TYPE_URL}/sections`,
    } as IEndpointData,
  },
};
